import React, { useEffect, useState } from 'react';
import {
  Typography,
  Paper,
  Box,
  Button,
} from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';
import { getEmpNotes } from 'core/API/logbook';
import { useQuery } from 'react-query';
import { useWorkplaceUser } from 'module/documents/utils';
import { formatDateToMMDDYYYY } from 'shared/utils/dates/formatDate';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const ViewEmployeeNotes = () => {
  const { noteId } = useParams<{ noteId?: string }>();
  const history = useHistory();
  const workplace = useWorkplaceUser();
  const workplaceId = parseInt(localStorage.getItem('workplace-id') || '1'); // Dynamic workplace ID from localStorage
  
  const [noteDate, setNoteDate] = useState('');
  const [noteContent, setNoteContent] = useState('');
  const [author, setAuthor] = useState('');

  const { data: empNotesData } = useQuery(
    ['empNotes', workplaceId],
    () => getEmpNotes({ workplaceId }),
    { enabled: !!workplaceId && !!noteId }
  );

  useEffect(() => {
    if (!noteId || !empNotesData) return;
    const list = Array.isArray(empNotesData?.member) ? empNotesData.member : [];
    const match = list.find((n: any) => {
      const idFromAtId = n['@id'] ? parseInt(String(n['@id']).split('/').pop()) : undefined;
      return idFromAtId === Number(noteId);
    });
    if (match) {
      const content = match.note || match.note_text || '';
      setNoteContent(content);
      setNoteDate(match.date || match.date_of_the_note || '');
      const auth = match.author;
      if (auth) {
        setAuthor(`${auth.firstName || auth.first_name || ''} ${auth.lastName || auth.last_name || ''}`.trim() || 'Unknown');
      } else if (workplace?.data) {
        setAuthor(`${workplace.data.firstName} ${workplace.data.lastName}`.trim() || 'Unknown');
      } else {
        setAuthor('System User');
      }
    }
  }, [noteId, empNotesData, workplace]);

  const formatDate = (dateString: string) => {
    return formatDateToMMDDYYYY(dateString);
  };

  return (
    <Box sx={{ backgroundColor: '#f4f6fa', minHeight: '100vh', py: 3 }}>
      <Box maxWidth="1100px" mx="auto">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Button
            onClick={() => history.goBack()}
            sx={{
              backgroundColor: 'rgb(68, 99, 136)',
              color: '#fff',
              textTransform: 'none',
              fontWeight: 500,
              px: 3,
              py: 0.75,
              '&:hover': { backgroundColor: 'rgb(57, 80, 111)' },
            }}
          >
            Back
          </Button>
        </Box>

        <Paper elevation={1}>
          <Box
            sx={{
              p: 2,
              bgcolor: 'grey.100',
              borderBottom: 1,
              borderColor: 'divider',
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h5" fontWeight={600}>
                View Employee Note
              </Typography>
            </Box>
          </Box>
          
          <Box
            sx={{
              px: 3,
              pt: 1.5,
              pb: 0.1
            }}
          >
            <Typography variant="subtitle2" gutterBottom>
              <strong>Employee:</strong> {author}
            </Typography>
            <Typography variant="subtitle2">
              <strong>Date:</strong> {formatDate(noteDate)}
            </Typography>
          </Box>
          
          <Box sx={{ p: 3 }}>
            <ReactQuill
              value={noteContent}
              readOnly={true}
              theme="snow"
              modules={{ toolbar: false }}
              className="quill-editor"
              style={{
                backgroundColor: 'white',
                height: '200px'
              }}
            />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default ViewEmployeeNotes;